/** Canonical backend parameters, matching the list's study filters. */
export const getStudyClassificationParams = (studyType: unknown, studyMode: unknown): Record<string, string> => {
	const params: Record<string, string> = {};
	const type = String(studyType ?? '').trim();
	const mode = String(studyMode ?? '').trim();
	if (type) params.studyType = type;
	if (mode) params['flag-mode'] = mode;
	return params;
};
